import axios from 'axios';

import { BASE_URL } from '../constants/apiConstants';

// Creating axios instance with custom configuration
const api = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});

api.interceptors.response.use(
    response => response.data,
    error => Promise.reject(error)
);

export default api;
